(function($){
  var eventSlider = {
    init: function(){
      if ($('.home-events__slider').length){
        eventSlider.initEventSlider();
      }
    },
    initEventSlider: function(){

      var $options = {
        prevNextButtons: false,
        autoPlay: 3000,
        wrapAround: true,
      };

      function sliderBreakPoints() {
        if ($(window).width() >= 1024) {
          $options.cellAlign = 'left';
          $options.contain = true;
        } else {
          $options.cellAlign = 'center';
          $options.contain = false;
        }
        $('.home-events__slider').flickity($options);
      }

      sliderBreakPoints();

      $(window).on('resize', function() {
        sliderBreakPoints();
      });


      $('.home-events__btns .btn-slider.m--prev').on('click', function(){
        $('.home-events__slider').flickity('previous');
      });
      $('.home-events__btns .btn-slider.m--next').on('click', function(){
        $('.home-events__slider').flickity('next');
      });
    }
  };
  $(document).ready(eventSlider.init);
})(jQuery);
